// ── SiteFooter — shared across all public pages ──────────────────────────────
import { useNavigate } from "react-router-dom";

const PRODUCTS = [
  {
    src: "/quantum.png",
    name: "Quantum Language",
    url: "https://quantum.quantumlogicslimited.com/",
  },
  {
    src: "/quantummeet.png",
    name: "QuantumMeet",
    url: "https://meet.quantumlogicslimited.com/",
  },
  {
    src: "/docssyncer.png",
    name: "DocsSyncer",
    url: "https://docssyncer.quantumlogicslimited.com/",
  },
];

export default function SiteFooter() {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-inner">
            {/* Brand column */}
            <div className="footer-brand-col">
              <div className="footer-logo-row">
                <img
                  src="/logo.png"
                  alt="Quantum Logics"
                  className="footer-logo-img"
                  width="23"
                  height="23"
                />
                <span className="footer-brand-name">Quantum Logics</span>
              </div>
              <p className="footer-tagline">
                Engineering the future,
                <br />
                one commit at a time.
              </p>
              {/* Social links */}
              <div className="footer-social">
                <a
                  href="https://github.com/SENODROOM"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  title="GitHub"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.202 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z" />
                  </svg>
                </a>
                <button className="social-link" title="LinkedIn">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </button>
                <button className="social-link" title="X / Twitter">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Link columns */}
            <div className="footer-links">
              <div>
                <div className="footer-group-label">Company</div>
                <div className="footer-link-list">
                  <button className="footer-link" onClick={() => navigate("/")}>
                    Home
                  </button>
                  <button
                    className="footer-link"
                    onClick={() => navigate("/jobs")}
                  >
                    Careers
                  </button>
                  {/* ✅ NEW: Training link */}
                  <button
                    className="footer-link"
                    onClick={() => navigate("/training")}
                  >
                    Training Program
                  </button>
                  <button
                    className="footer-link"
                    onClick={() => console.log("About")}
                  >
                    About
                  </button>
                  <button
                    className="footer-link"
                    onClick={() => console.log("Blog")}
                  >
                    Blog
                  </button>
                </div>
              </div>

              <div>
                <div className="footer-group-label">Products</div>
                <div className="footer-link-list">
                  {PRODUCTS.map((p) => (
                    <a
                      key={p.url}
                      href={p.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link footer-product-link"
                    >
                      <img
                        src={p.src}
                        alt={p.name}
                        width="14"
                        height="14"
                        style={{ borderRadius: 3, objectFit: "contain" }}
                      />
                      {p.name}
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <div className="footer-group-label">Legal</div>
                <div className="footer-link-list">
                  <button
                    className="footer-link"
                    onClick={() => console.log("Privacy Policy")}
                  >
                    Privacy Policy
                  </button>
                  <button
                    className="footer-link"
                    onClick={() => console.log("Terms of Service")}
                  >
                    Terms of Service
                  </button>
                  <button
                    className="footer-link"
                    onClick={() => console.log("Security")}
                  >
                    Security
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <span className="footer-copy">
            © 2025 Quantum Logics. All rights reserved.
          </span>
          <span className="footer-made">Made with ⚡ in Lahore, Pakistan</span>
        </div>
      </div>
    </footer>
  );
}
